import React, { useState } from "react";
import ModalHeader from "../../../components/ui/ModalHeader";
import { DynamicField } from "../../../components/ui/DynamicField";
import SinglePlanOverView from "./SinglePlanOverView";
import { InputField } from "../../../components/common/InputField";
import { SinglePlanOverviewModalInput } from "../../../config/singleWorkout";
import UploadedBanner from "../../../components/common/UploadNewBanner";
import { useMediaStore } from "../../../store";
import { SearchableSelectField } from "../../../components/common/SearchableSelectField";

const AllSinglePlanModel = ({
                              jsonData,
                              onClose,
                              planData,
                              onSubmit,
                              selectedPlanId,
                              setUploadedJson,
                              handleImageUrlChange,
                              handleVideoUrlChange,
                              imageUrl,
                              videoUrl,
                            }) => {
  const { imageUrls: bannerOptions, videoUrls: videoOptions } = useMediaStore();

  const [categories, setCategories] = useState(jsonData?.categories);
  const [uploadedJson, setLocalUploadedJson] = useState(jsonData);

  const handleCategoryChange = (categoryIndex, field, value) => {
    const updatedCategories = [...categories];
    updatedCategories[categoryIndex][field] = value;
    setCategories(updatedCategories);
  };

  const handleExerciseChange = (categoryIndex, exerciseIndex, field, value) => {
    const updatedCategories = [...categories];
    updatedCategories[categoryIndex].exercises[exerciseIndex][field] = value;
    setCategories(updatedCategories);
  };


  const handleMediaUrlChange = (categoryIndex, exerciseIndex, isImage, value) => {
    const field = isImage ? "image_url" : "video_url";
    const updatedCategories = [...categories];
    updatedCategories[categoryIndex].exercises[exerciseIndex][field] = value;
    setCategories(updatedCategories);

    const updatedJson = {
      ...uploadedJson,
      categories: updatedCategories,
    };

    setLocalUploadedJson(updatedJson);
    setUploadedJson(updatedJson);
  };

  return (
    <>
      <div
        className="modal fade show"
        id="exampleAllPlanModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel3"
        aria-hidden="true"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <ModalHeader onClose={onClose} />
            <div className="modal-body">
              <div className="row">
                <SinglePlanOverView
                  jsonData={jsonData}
                  planData={planData}
                  selectedPlanId={selectedPlanId}
                  handleImageUrlChange={handleImageUrlChange}
                  handleVideoUrlChange={handleVideoUrlChange}
                  imageUrl={imageUrl}
                  videoUrl={videoUrl}
                />
              </div>
              <div className="row">
                <div className="col-sm-2 mb-3"></div>
                <div className="col-sm-10 mb-3">
                  <div className="col-sm-12 mb-3">
                    {categories?.map((category, categoryIndex) => (
                      <div key={categoryIndex} className="col-12 mb-4">
                        <div className="col-8 mb-4">
                          <hr className="border-2 bg-dark" />
                          <InputField
                            label="Sub-Category"
                            type="text"
                            id={category.id}
                            value={category.sub_category}
                            onChange={(e) =>
                              handleCategoryChange(
                                categoryIndex,
                                "sub_category",
                                e.target.value
                              )
                            }
                            disabled={false}
                          />
                          <hr className="border-2 bg-dark" />
                        </div>
                        {category.exercises.map((exercise, exerciseIndex) => (
                          <div key={exerciseIndex} className="row my-5">
                            <div className="col-sm-8">
                              <div className="col-sm-12 d-flex flex-wrap">
                                {SinglePlanOverviewModalInput.map(
                                  (inputConfig, inputIndex) => (
                                    <div
                                      key={inputIndex}
                                      className="me-2 flex-fill"
                                      style={{ minWidth: "200px" }}
                                    >
                                      <div className="mb-2">
                                        <DynamicField
                                          label={inputConfig.label}
                                          type={inputConfig.type}
                                          value={
                                            exercise[inputConfig.valueKey] ??
                                            "No data"
                                          }
                                          options={inputConfig.options}
                                          onChange={(e) =>
                                            handleExerciseChange(
                                              categoryIndex,
                                              exerciseIndex,
                                              inputConfig.valueKey,
                                              e.target.value
                                            )
                                          }
                                          disabled={![
                                            "exercise_number",
                                            "name",
                                          ].includes(inputConfig.valueKey)}
                                        />
                                      </div>
                                    </div>
                                  )
                                )}



                              </div>
                              <SearchableSelectField
                                key={`${categoryIndex}${exerciseIndex}_img`}
                                label={'search Banner Image URL'}
                                id={'image_search'}
                                options={bannerOptions
                                }
                                value={exercise[exercise.image_url]}
                                onChange={(value) => handleMediaUrlChange( categoryIndex, exerciseIndex, true, value) }
                              />



                              <SearchableSelectField
                                key={`${categoryIndex}${exerciseIndex}_vid`}
                                label={'search Video URL'}
                                id={'videoUrl_search'}
                                options={videoOptions}
                                value={exercise[exercise.video_url]}
                                onChange={(value) => handleMediaUrlChange( categoryIndex, exerciseIndex, false, value) }
                              />
                            </div>
                            <div className="col-sm-4">
                              <UploadedBanner key={`${categoryIndex}-${exerciseIndex}`} defaultImage={exercise.image_url}
                                              prama = {{categoryIndex,exerciseIndex}}
                                              uploadimage={handleMediaUrlChange} />
                              {/* <button
                                className="btn btn-success mt-3"
                                onClick={() =>
                                  handleSaveWorkout(categoryIndex, exerciseIndex)
                                }
                              >
                                Save Workout
                              </button> */}
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {!selectedPlanId ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => onSubmit(categories)}
                >
                  Save & Next
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => onSubmit(categories)}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onClose}
                  >
                    Close
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default AllSinglePlanModel;
